import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-info__container" }
const _hoisted_2 = { class: "hotel-info" }
const _hoisted_3 = { class: "hotel-info__header" }
const _hoisted_4 = { class: "hotel-info__address" }

import HotelStars from '@lmt-rpb/HotelStars/HotelStars.vue';
import CustomerReviewsRatings from '@lmt-rpb/CustomerReviewsRatings/CustomerReviewsRatings.vue';
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import type { HotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import { computed } from 'vue';
import { isClientGermany } from '@utils/environmentUtils';
import { EventBus } from '@global-js/event-bus';
import { ratingText, isMinimumRating } from '@utils/utils';
import { gaSelectContentAttr } from 'src/utils/analytics';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	hotel: HotelData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelRatings',
  props: {
    hotel: {}
  },
  setup(__props: any) {

const props = __props;
const showSuns = isClientGermany();
const { isMobile } = storeToRefs(useBreakpointStore());
const hotelDetails = computed(() => ({
	Hotel: props.hotel.Hotel,
	Location: props.hotel.Location,
	RatingCount: props.hotel.RatingCount,
	RatingOverallValue: props.hotel.RatingOverallValue,
	RatingRecommendationRate: props.hotel.RatingRecommendationRate,
}));

const ratingDescription = computed(() => {
	let rating = '';
	if (isMinimumRating(hotelDetails.value.RatingOverallValue)) {
		rating = `${ratingText(hotelDetails.value.RatingOverallValue)} – `;
	}
	return rating;
});

const rating = Number(hotelDetails.value.Hotel?.Category);

const address = hotelDetails.value.Location.Address ? hotelDetails.value.Location.Address.join('; ') : '';

const openMap = () => {
	EventBus.$emit('hotel:openMap');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(hotelDetails.value.Hotel.Name), 1 /* TEXT */),
        _createVNode(HotelStars, {
          class: "hotel-info__stars",
          "show-suns": _unref(showSuns),
          rating: _unref(rating)
        }, null, 8 /* PROPS */, ["show-suns", "rating"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseIcon, {
          class: "hotel-info__icon",
          name: "marker",
          viewBox: "0 2 20 27"
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(address)), 1 /* TEXT */),
        _createElementVNode("a", _mergeProps({ class: "hotel-info__link" }, _unref(gaSelectContentAttr)({ cId: 'hotelinfo_map_link' }), {
          onClick: _withModifiers(openMap, ["prevent"])
        }), " Auf Karte anzeigen ", 16 /* FULL_PROPS */)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, {
      defer: "",
      to: _unref(isMobile) ? '#hotel-gallery' : '.hotel-info__container'
    }, [
      _createVNode(CustomerReviewsRatings, {
        class: "hotel-info__ratings",
        "before-gallery": !_unref(isMobile),
        "after-gallery": _unref(isMobile),
        rating: _unref(rating),
        "rating-count": hotelDetails.value.RatingCount,
        "recommendation-rate": hotelDetails.value.RatingRecommendationRate,
        "rating-label": ratingDescription.value,
        "rating-overall-value": hotelDetails.value.RatingOverallValue
      }, null, 8 /* PROPS */, ["before-gallery", "after-gallery", "rating", "rating-count", "recommendation-rate", "rating-label", "rating-overall-value"])
    ], 8 /* PROPS */, ["to"]))
  ]))
}
}

})